module.exports = __webpack_public_path__ + "7c3534d2a5479e0af0f13f5c8a8723cc.svg";